var _defs, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLtEstOffers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}.c{fill:#c0272d;}.d{fill:#fbb817;}.e{fill:#006b44;}.f{fill:#2b71b8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M68.43,72.26c9.69,0,17.93-6.2,20.99-14.84H47.44c3.06,8.65,11.3,14.84,20.99,14.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M47.44,42.58c-.82,2.32-1.27,4.82-1.27,7.42s.45,5.1,1.27,7.42h41.98c.82-2.32,1.27-4.82,1.27-7.42s-.45-5.1-1.27-7.42H47.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M68.43,27.74c-9.69,0-17.93,6.2-20.99,14.84h41.98c-3.06-8.65-11.3-14.84-20.99-14.84Z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.57,72.26c9.69,0,17.93-6.2,20.99-14.84H10.57c3.06,8.65,11.3,14.84,20.99,14.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.57,42.58c-.82,2.32-1.27,4.82-1.27,7.42s.45,5.1,1.27,7.42H52.56c.82-2.32,1.27-4.82,1.27-7.42s-.45-5.1-1.27-7.42H10.57Z",
    style: {
      fill: "black"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M31.57,27.74c-9.69,0-17.93,6.2-20.99,14.84H52.56c-3.06-8.65-11.3-14.84-20.99-14.84Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtEstOffers);
export default __webpack_public_path__ + "static/media/lt-est-offers.235fdc4d838724801d6b1d395bbbdca8.svg";
export { ForwardRef as ReactComponent };